import { render, staticRenderFns } from "./seat-clamp.vue?vue&type=template&id=5b2e7c65&scoped=true"
import script from "./seat-clamp.vue?vue&type=script&lang=js"
export * from "./seat-clamp.vue?vue&type=script&lang=js"
import style0 from "./seat-clamp.vue?vue&type=style&index=0&id=5b2e7c65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e7c65",
  null
  
)

export default component.exports